import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
// Define route-to-title mappings
var pageTitleMappings = {
    '/insights/home': 'app.pageTitle.home',
    '/insights/academic_office': 'app.pageTitle.academicsAndOffices',
    '/insights/settings': 'app.pageTitle.settings',
    '/insights/planning/home': 'app.pageTitle.planning',
    '/insights/unauthorized': 'app.pageTitle.unauthorized',
};
// Pattern-based mappings for dynamic routes
var getPatternBasedTitle = function (pathname) {
    if (pathname.match(/^\/insights\/institution\/[^\/]+$/)) {
        return 'app.pageTitle.institutionDetails';
    }
    if (pathname.match(/^\/insights\/institution\/[^\/]+\/organization\/[^\/]+$/)) {
        return 'app.pageTitle.organizationInsights';
    }
    if (pathname.match(/^\/insights\/institution\/[^\/]+\/program\/[^\/]+$/)) {
        return 'app.pageTitle.programInsights';
    }
    if (pathname.match(/^\/insights\/planning\/institution\/[^\/]+\/organization\/[^\/]+$/)) {
        return 'app.pageTitle.planningOrganization';
    }
    if (pathname.match(/^\/insights\/.*\/html$/)) {
        return 'app.pageTitle.exportView';
    }
    return null;
};
export var usePageTitle = function (customTitle) {
    var location = useLocation();
    var intl = useIntl();
    useEffect(function () {
        var updateTitle = function () {
            var insightsHub = intl.formatMessage({ id: 'app.pageTitle.insightsHub' });
            var pageTitle = insightsHub; // Default fallback
            if (customTitle) {
                // If a custom title is provided, use it
                pageTitle = "".concat(customTitle, " - ").concat(insightsHub);
            }
            else {
                // Try to get title from route mappings
                var mappedTitleKey = pageTitleMappings[location.pathname];
                if (mappedTitleKey) {
                    var translatedTitle = intl.formatMessage({ id: mappedTitleKey });
                    pageTitle = "".concat(translatedTitle, " - ").concat(insightsHub);
                }
                else {
                    // Try pattern-based matching
                    var patternTitleKey = getPatternBasedTitle(location.pathname);
                    if (patternTitleKey) {
                        var translatedTitle = intl.formatMessage({ id: patternTitleKey });
                        pageTitle = "".concat(translatedTitle, " - ").concat(insightsHub);
                    }
                    else {
                        // Try to extract from page header element
                        var titleElement = document.querySelector('.page-header .title');
                        if (titleElement === null || titleElement === void 0 ? void 0 : titleElement.textContent) {
                            pageTitle = "".concat(titleElement.textContent, " - ").concat(insightsHub);
                        }
                    }
                }
            }
            document.title = pageTitle;
        };
        // Update title immediately
        updateTitle();
        // Also update after a short delay to catch dynamically loaded content
        var timeoutId = setTimeout(updateTitle, 100);
        return function () { return clearTimeout(timeoutId); };
    }, [location.pathname, customTitle, intl]);
};
